import { render, staticRenderFns } from "./LEDStrip.vue?vue&type=template&id=8a7f23da&scoped=true&"
import script from "./LEDStrip.vue?vue&type=script&lang=js&"
export * from "./LEDStrip.vue?vue&type=script&lang=js&"
import style0 from "./LEDStrip.vue?vue&type=style&index=0&id=8a7f23da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7f23da",
  null
  
)

export default component.exports